import { useI18n } from '@change-corgi/core/react/i18n';

import { usePromotePageData, usePromotePageState } from 'src/app/pages/promote/pageContext';
import { useCreateUser, useIsSecureGuest, useSetPxGuestUserData } from 'src/app/shared/hooks/payments';
import type { PaymentType } from 'src/app/shared/utils/payments';

import { useUserInfo } from '../../../useUserInfo';

export function useCreateUserWrapper(): (paymentType: PaymentType) => Promise<boolean> {
	const {
		data: {
			petition: { slug },
			featureConfigs: { doubleOptinEnabledNewUser, googleAuthEnabled },
		},
	} = usePromotePageData();
	const isSecureGuest = useIsSecureGuest(doubleOptinEnabledNewUser);
	const [{ email }, { clearLoading, setGeneralErrorMessage }] = usePromotePageState();
	const createUser = useCreateUser();
	const { translate } = useI18n();
	const setPxGuestUserData = useSetPxGuestUserData();
	const userInfo = useUserInfo();

	return async function createUserWrapper(paymentType: PaymentType): Promise<boolean> {
		if (isSecureGuest !== false) {
			setPxGuestUserData(email);
			return true;
		}

		const path = `/p/${encodeURIComponent(slug)}/promote`;
		const result = await createUser({
			...userInfo(paymentType),
			googleAuthEnabled,
			path,
			signupContext: 'payment_promotion',
		});
		if (result.success) return true;

		if (!result.isUserAlreadyExistsError) {
			setGeneralErrorMessage(translate('corgi.co.promote.generic_payment_error'));
		} else if (paymentType === 'paypal') {
			setGeneralErrorMessage(translate('fe.errors.paypal.complete_transaction_after_login'));
		} else {
			clearLoading();
		}
		return false;
	};
}
